import { VenueBasedEventSerializer } from "@app-contexts/dashboard/features/events/data/types/events";
import { PublicCharitySerializer } from "@app-contexts/public/features/event-detail/data/types/charity";
import usePublicCharityService from "@app-contexts/public/features/event-detail/data/services/usePublicCharityService";
import { enums, enumsTypes } from "@shared/constants";
import { PublicBaseEventSerializer } from "@shared/modules/events/types/public";

/**
 * Shared hook to get charity information for a given event.
 * Supports native charity API and works with both public and venue-based events.
 *
 * @param causeId - The charity ID to fetch
 * @param event - The event object (public or venue-based)
 * @returns Charity data, loading state, and currency information
 */
export function useCharity(
  causeId: string | undefined,
  event: PublicBaseEventSerializer | VenueBasedEventSerializer | undefined
): {
  isLoading: boolean;
  isError: boolean;
  charityCurrency: enumsTypes.CurrencyMapIdType;
  cause: PublicCharitySerializer | undefined;
} {
  const { useRetrieve } = usePublicCharityService();
  const {
    data: cause,
    isLoading,
    isError,
  } = useRetrieve(causeId || "", {
    options: {
      enabled: Boolean(event) && Boolean(causeId),
    },
  });
  const charityCurrency = cause?.currency_type || enums.CURRENCY_MAP.CAD.key;

  return {
    isLoading,
    isError,
    charityCurrency,
    cause,
  };
}
